import Gldb from "./gidb";
var db = '';
var initDB = function initDB() {
  if (db) return db;
  db = new Gldb({
    databaseName: 'ZZ_LEGO_DATAS',
    version: 1
  });
  db.createStore('baseInfo', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('logs', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('events', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('failEvents', {
    keyPath: 'id',
    autoIncrement: true
  });
  // db.version(1).stores({
  //   baseInfo: "++id, time, data",
  //   logs: "++id, *type, time, data",
  //   events: "++id, *actiontype, *pagetype, time, data, status, msg",
  //   failEvents: "++id, code, time, data, retryNum"
  // })
  return db;
};
export default initDB;